import {
  computed,
  DestroyRef,
  inject,
  Injectable,
  signal
} from '@angular/core';

// 1279px minimum dashboard content width + the 400px rail: the narrowest
// viewport that can seat the panel without squeezing the dashboard.
const MIA_PANEL_REFLOW_BREAKPOINT_PX = 1679;

@Injectable({ providedIn: 'root' })
export class AiPanelService {
  private readonly _visible = signal(false);
  private readonly _isEnabled = signal(false);
  private readonly viewportWidth = signal(window.innerWidth);

  readonly visible = this._visible.asReadonly();
  readonly isEnabled = this._isEnabled.asReadonly();

  /**
   * Below the reflow breakpoint the rail overlays the dashboard instead of
   * pushing it aside. Stacking depends on this: a floating rail has to clear
   * page content, a docked one has to sit under the app chrome (PMDEV-9835).
   */
  readonly isFloating = computed(
    () => this.viewportWidth() < MIA_PANEL_REFLOW_BREAKPOINT_PX
  );

  constructor() {
    const onResize = (): void => this.viewportWidth.set(window.innerWidth);
    window.addEventListener('resize', onResize);
    inject(DestroyRef).onDestroy(() =>
      window.removeEventListener('resize', onResize)
    );
  }

  toggle(): void {
    this._visible.update((v) => !v);
  }

  set(visible: boolean): void {
    this._visible.set(visible);
  }

  setIsEnabled(enabled: boolean): void {
    this._isEnabled.set(enabled);
    if (!enabled) {
      this._visible.set(false);
    }
  }
}
